import { propertyGroupQueryKeys as e } from "./propertyGroupQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyGroupsApi as r } from "@maat/api-main";
//#region src/propertyGroups/useCreatePropertyGroupMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createGroup(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreatePropertyGroupMutation };
